module.exports = "/assets/landing-rw/instagram/insta-feed-3.jpg?y2uq9kE";